import React from "react";
import "./styles.css";

const GroupBDRBiorepositoryOps = ({ description }) => {
    return (
        <div className="userTag biorepository">
            <p>{description ? description : "BIOREPOSITORY OPS"}</p>
        </div>
    );
};

export default GroupBDRBiorepositoryOps;